import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import AppContext from 'context/Context';
import { post } from 'services/skill-matric-services/smSkillCriteriaService';

const SkillCriteriaModal = ({
  isShow,
  skillActivityId,
  skillLevelId,
  handleClose,
  handleSubmit,
  criteriaDes
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const [formData, setFormData] = useState({});
  const [des, setDes] = useState('');

  useEffect(() => {
    setDes(criteriaDes);
  },[criteriaDes])

  const handleChange = ({ target }) => {
    console.log(formData);
    let name = target.name;
    let value = target.value;
    setDes(value)
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async e => {
    console.log('submit');
    e.preventDefault();
    await post({ id: uuid(), ...formData, skillActivityId, skillLevelId });
    handleSubmit();
  };

  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {criteriaDes ? 'Edit ' : 'Create '} Skill Criteria
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3" controlId="titleInput">
            <Form.Label className="fs-0">Description</Form.Label>
            <Form.Control
              type="text"
              as="textarea"
              name="description"
              required
              value={des}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

SkillCriteriaModal.propTypes = {
  skillLevelId: PropTypes.number,
  skillActivityId: PropTypes.number,
  isShow: PropTypes.bool,
  criteriaDes: PropTypes.number,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default SkillCriteriaModal;
